import { render, staticRenderFns } from "./FavoriteJobs.vue?vue&type=template&id=5543bad4&"
import script from "./FavoriteJobs.vue?vue&type=script&lang=js&"
export * from "./FavoriteJobs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports